<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">
  <div class="timeline-body">

    <div class="col-sm-12">

      <div class="col-sm-12">
        <h3>
          <span>Lista das despesas</span>
          <button (click)="openModalAddDetalhamentoFinanceiro(formAdicionarDetalhamentoFinanceiro)"
            class="btn btn-default btn-sm pull-right">Add despesa</button>
          <button (click)="calculaResumoDetalhamento()" class="btn btn-primary btn-sm pull-right"
            style="margin-right: 10px;">Ver resumo</button>
        </h3>
        <hr>

        <div class="position-button-floating animated fadeIn text-center">
          <button (click)="calculaResumoDetalhamento()" class="btn btn-primary btn-sm pull-right"
            style="margin-bottom: 10px;">Ver resumo</button>
          <button (click)="openModalAddDetalhamentoFinanceiro(formAdicionarDetalhamentoFinanceiro)"
            class="btn btn-default btn-sm pull-right">Add despesa</button>
        </div>
      </div>

      <div class="col-sm-12">
        <div *ngFor="let despesa of listDetalhamentoFinanceiro; let index = index;">
          <div class="col-sm-12">
            <h3><b>Despesa {{index+1}}:</b> &nbsp; {{ despesa.especificacao }}</h3>
            <ul class="tree">
              <li style="color: #777;">Tipo: <b> {{ retornaTipo(despesa.tipo) }}</b></li>
              <li style="color: #777;">Categoria: <b>
                  {{ despesa.categoria ? verificaCategoria(despesa.categoria.id) : 'Não definido' }}</b></li>
              <li style="color: #777;">Valor: <b>
                  {{ calculaDespesa(despesa) | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>
            </ul>

            <hr style="margin: 10px 0 3px;">

            <span class="badge bg-red cursor pull-right" pTooltip="Excluir" tooltipPosition="top"
              style="margin-left: 5px;" (click)="confirmarExclusaoDetalhamentoFinanceiro(despesa)"><i
                class="fa fa-fw fa-trash"></i></span>
            <span class="badge bg-gray cursor pull-right" pTooltip="Editar" tooltipPosition="top"
              (click)="openModalEditarDetalhamentoFinanceiro(despesa)"><i class="fas fa-pencil-alt"></i></span>


            <br>
            <br>

          </div>

          <div class="col-sm-12">
            <table class="table table-bordered">
              <tbody *ngIf="despesa.tipo == 'Pessoa_horista'">
                <tr>
                  <th colspan="8">
                    Detalhamento
                    <button
                      (click)="openModalAddDetalhamento(despesa, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisico, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisicoCeletista, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisicoHorista)"
                      class="btn btn-primary btn-xs pull-right"> Add detalhamento</button>
                  </th>
                </tr>
                <tr>
                  <th>Etapa no cronograma</th>
                  <th>Especificação</th>
                  <th class="text-center">UN</th>
                  <th class="text-center">QTD</th>
                  <th>Valor Unitário</th>
                  <th>20% INSS</th>
                  <th>Valor Total</th>
                  <th class="text-center" style="min-width: 85px;">Ações</th>
                </tr>

                <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                  <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                  <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                  <td>{{ detalhamento.especificacao }}</td>
                  <td class="text-center">{{ detalhamento.un }}</td>
                  <td class="text-center">{{ detalhamento.quantidade }}</td>
                  <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  <td>
                    {{ soma20Inss(detalhamento.quantidade, detalhamento.valorUnitario) | currency:'BRL':'symbol-narrow':'1.2-2' }}
                  </td>
                  <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  <td class="text-center">
                    <span class="badge bg-gray cursor" pTooltip="Editar" tooltipPosition="top"
                      (click)="openModalEditarDetalhamentoFinanceiroHasEtapaCronogramaFisicoHorista(detalhamento, despesa.id)"><i
                        class="fa fa-fw fa-pencil"></i></span>
                    <span class="badge bg-red cursor" pTooltip="Excluir" tooltipPosition="top"
                      (click)="confirmarExclusaoDetalhamento(detalhamento)"><i class="fa fa-fw fa-trash"></i></span>
                  </td>
                </tr>

              </tbody>

              <tbody *ngIf="despesa.tipo != 'Pessoa_horista' && despesa.tipo != 'Pessoa_celetista'">
                <tr>
                  <th colspan="7">
                    Detalhamento
                    <button
                      (click)="openModalAddDetalhamento(despesa, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisico, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisicoCeletista, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisicoHorista)"
                      class="btn btn-primary btn-xs pull-right"> Add detalhamento</button>
                  </th>
                </tr>
                <tr>
                  <th>Etapa no cronograma</th>
                  <th>Especificação</th>
                  <th class="text-center">UN</th>
                  <th class="text-center">QTD</th>
                  <th>Valor Unitário</th>
                  <th>Valor Total</th>
                  <th class="text-center" style="min-width: 85px;">Ações</th>
                </tr>

                <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                  <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                  <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                  <td>{{ detalhamento.especificacao }}</td>
                  <td class="text-center">{{ detalhamento.un }}</td>
                  <td class="text-center">{{ detalhamento.quantidade }}</td>
                  <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  <td class="text-center">
                    <span class="badge bg-gray cursor" pTooltip="Editar" tooltipPosition="top"
                      (click)="openModalEditarDetalhamentoPadrao(detalhamento, despesa.id)"><i
                        class="fa fa-fw fa-pencil"></i></span>
                    <span class="badge bg-red cursor" pTooltip="Excluir" tooltipPosition="top"
                      (click)="confirmarExclusaoDetalhamento(detalhamento, despesa)"><i
                        class="fa fa-fw fa-trash"></i></span>
                  </td>
                </tr>

              </tbody>

              <tbody *ngIf="despesa.tipo == 'Pessoa_celetista'">
                <tr>
                  <th colspan="7">
                    Detalhamento
                    <button
                      (click)="openModalAddDetalhamento(despesa, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisico, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisicoCeletista, formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisicoHorista)"
                      class="btn btn-primary btn-xs pull-right"> Add detalhamento</button>
                  </th>
                </tr>
                <tr>
                  <th>Função</th>
                  <th class="text-center">Meses</th>
                  <th class="text-center">QTD</th>
                  <th>Salário</th>
                  <th>Total Unitário</th>
                  <th>Total Geral</th>
                  <th class="text-center" style="min-width: 85px;">Ações</th>
                </tr>
                <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                  <td>{{ detalhamento.funcao }}</td>
                  <td class="text-center">{{ detalhamento.mes }}</td>
                  <td class="text-center">{{ detalhamento.quantidade }}</td>
                  <td>{{ detalhamento.salario | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                  <td>{{ detalhamento.totalUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  <td class="text-center">
                    <span class="badge bg-gray cursor" pTooltip="Editar" tooltipPosition="top"
                      (click)="openModalEditarDetalhamentoFinanceiroHasEtapaCronogramaFisicoCeletista(detalhamento, despesa.id)"><i
                        class="fa fa-fw fa-pencil"></i></span>
                    <span class="badge bg-red cursor" pTooltip="Excluir" tooltipPosition="top"
                      (click)="confirmarExclusaoDetalhamento(detalhamento, despesa)">
                      <i class="fa fa-fw fa-trash"></i>
                    </span>
                  </td>
                </tr>
              </tbody>

            </table>

          </div>

          <div class="col-md-12 no-padding" id="despesa-smoth-{{index}}">
            <hr>
          </div>

        </div>
      </div>


    </div>

  </div>

  <div class="timeline-footer" style="padding: 10px 10px;">
    <a class="btn btn-primary btn-sm" (click)="openEtapa5()">Voltar</a>&nbsp;&nbsp;
    <a class="btn btn-primary btn-sm" (click)="openEtapa7()">Próximo</a>
  </div>
</div>


<!-- MODAIS -->
<p-dialog [style]="{width: '600px'}" header="Nova despesa" [(visible)]="modalAdicionarDetalhamentoFinanceiro" showEffect="fade"
  [modal]="true">
  <form #formAdicionarDetalhamentoFinanceiro="ngForm" autocomplete="off" (ngSubmit)="adicionarDetalhamentoFinanceiro()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Tipo</label>
        <p-select name="tipo" (onChange)="tipoDespesaSelecionada($event.value)" [options]="tipoDespesa"
          placeholder="Selecione" [(ngModel)]="detalhamentoFinanceiroAdd.tipo"
          required></p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Categoria</label>
        <p-select [disabled]="pessoaCeletistaSelecionada" name="categoria" [options]="listaCategorias"
          placeholder="Selecione" 
          [(ngModel)]="detalhamentoFinanceiroAdd.categoria.id" required></p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Especificação</label>
        <input pInputText type="text" name="especificacao" [(ngModel)]="detalhamentoFinanceiroAdd.especificacao"
          required>
      </div>

    </div>
    <div class="ui-g-12">
      <button pButton type="submit" label="Salvar" [disabled]="formAdicionarDetalhamentoFinanceiro.invalid"></button>
    </div>

  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarDetalhamentoFinanceiro()" header="Editar despesa"
  [(visible)]="modalEditarDetalhamentoFinanceiro" showEffect="fade" [modal]="true">
  <form #formAlterarDetalhamentoFinanceiro="ngForm" autocomplete="off" (ngSubmit)="alterarDetalhamentoFinanceiro()">
    <div class="ui-g">
      <div class="ui-g-4 ui-fluid">
        <label>*Tipo</label>
        <p-select name="tipo" disabled [options]="tipoDespesa" placeholder="Selecione"
          [filter]="true" [(ngModel)]="detalhamentoFinanceiroEditar.tipo" required></p-select>
      </div>
      <div class="ui-g-8 ui-fluid">
        <label>*Categoria</label>
        <p-select name="categoria" disabled [options]="listaCategoriasEditar" placeholder="Selecione" [filter]="true" [(ngModel)]="detalhamentoFinanceiroEditar.categoria.id" required>
        </p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Especificação</label>
        <input pInputText type="text" name="especificacao" [(ngModel)]="detalhamentoFinanceiroEditar.especificacao"
          required>
      </div>

      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAlterarDetalhamentoFinanceiro.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarDetalhamentoPadrao()" header="Editar especificação"
  [(visible)]="modalEditarDetalhamento" showEffect="fade" [modal]="true">
  <form #formEditarDetalhamentoFinanceiroHasEtapaCronogramaFisico="ngForm" autocomplete="off"
    (ngSubmit)="alterarDetalhamentoPadrao(formEditarDetalhamentoFinanceiroHasEtapaCronogramaFisico)">
    <div class="ui-g">
      <div class="ui-g-4 ui-fluid">
        <label>*Meta do cronograma físico</label>
        <p-select disabled name="metaCronogramaFisico" [(ngModel)]="metaEditarNgModel"
          [options]="listaMetaCronogramaFisico" placeholder="Selecione" [filter]="true" required>
        </p-select>
      </div>
      <div class="ui-g-4 ui-fluid">
        <label>*Etapa do cronograma físico</label>
        <p-select disabled name="etapaCronogramaFisico" [(ngModel)]="etapaEditarNgModel"
          [options]="listaEtapaCronogramaFisicoEditar" placeholder="Selecione" [filter]="true"
          required></p-select>
      </div>

      <div class="ui-g-4 ui-fluid" *ngIf="mostraAtrEquipMatPerm">
        <div class="form-group">
          <label>*Equipamento/material permanente?</label>
          <div class="radio">
            <label>
              <input type="radio" name="optionsRadios" id="optionsRadios1"
                [(ngModel)]="detalhamentoEditar.equipamentoMaterialPermanente" value="true"> Sim
            </label>
            &nbsp;&nbsp;&nbsp;
            <label>
              <input type="radio" name="optionsRadios" id="optionsRadios2"
                [(ngModel)]="detalhamentoEditar.equipamentoMaterialPermanente" value="false"> Não
            </label>
            &nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </div>

      <input pInputText type="text" name="nomeEtapa" hidden [(ngModel)]="detalhamentoEditar.nomeEtapa">
      
      <div class="ui-g-12 ui-fluid">
        <label>*Especificação</label>
        <input pInputText type="text" name="especificacao" [(ngModel)]="detalhamentoEditar.especificacao" required>
      </div>
      <div class="ui-g-12 ui-md-6 ui-fluid">
        <label>*UN</label>
        <input pInputText type="text" name="un" [(ngModel)]="detalhamentoEditar.un" required>
      </div>
      <div class="ui-g-12 ui-md-6 ui-fluid">
        <label>*Quantidade</label>
        <input pInputText type="number" (input)="somarValorTotal()" name="quantidade"
          [(ngModel)]="detalhamentoEditar.quantidade" required>
      </div>
      <div class="ui-g-12 ui-md-3 ui-fluid">
        <label>*Valor Unitário</label>
        <input pInputText type="text" (keyup)="somarValorTotal()" name="valorUnitario" placeholder="R$ 0,00"
          currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false }"
          [(ngModel)]="detalhamentoEditar.valorUnitario" required>
      </div>
      <div class="ui-g-12 ui-md-3 ui-fluid">
        <label>*Valor Total</label>
        <input pInputText type="text" disabled name="valorTotal" placeholder="R$ 0,00" currencyMask
          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false }"
          [(ngModel)]="detalhamentoEditar.valorTotal" required>
      </div>

    </div>
    <div class="ui-g-12">
      <button pButton type="submit" label="Salvar"
        [disabled]="formEditarDetalhamentoFinanceiroHasEtapaCronogramaFisico.invalid"></button>
    </div>

  </form>
</p-dialog>

<p-dialog [style]="{width: '800px'}" header="Nova especificação"
  [(visible)]="modalAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisico" showEffect="fade"
  [modal]="true">
  <form #formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisico="ngForm" autocomplete="off"
    (ngSubmit)="adicionarDetalhamentoPadrao()">
    <div class="ui-g">
      <div class="ui-g-6 ui-fluid">
        <label>*Meta do cronograma físico</label>
        <p-select name="metaCronogramaFisico" [(ngModel)]="metaNgModel" (onChange)="metaSelecionada($event.value)"
          [options]="listaMetaCronogramaFisico" placeholder="Selecione" [filter]="true" required>
        </p-select>
      </div>
      <div class="ui-g-6 ui-fluid">
        <label>*Etapa do cronograma físico</label>
        <p-select name="etapaCronogramaFisico"
          [(ngModel)]="detalhamentoFinanceiroHasEtapaCronogramaFisicoAdd.etapaCronogramaFisico.id"
          [options]="listaEtapaCronogramaFisico" placeholder="Selecione" [filter]="true" required>
        </p-select>
      </div>

      <div class="ui-g-12 ui-fluid">
        <label>*Especificação</label>
        <input pInputText type="text" name="especificacao"
          [(ngModel)]="detalhamentoFinanceiroHasEtapaCronogramaFisicoAdd.especificacao" required>
      </div>
      <div class="ui-g-12 ui-md-6 ui-fluid">
        <label>*UN</label>
        <input pInputText type="text" name="un" [(ngModel)]="detalhamentoFinanceiroHasEtapaCronogramaFisicoAdd.un"
          required>
      </div>
      <div class="ui-g-12 ui-md-6 ui-fluid">
        <label>*Quantidade</label>
        <input pInputText type="number" (input)="somarValorTotal()" name="quantidade"
          [(ngModel)]="detalhamentoFinanceiroHasEtapaCronogramaFisicoAdd.quantidade" required>
      </div>
      <div class="ui-g-12 ui-md-3 ui-fluid">
        <label>*Valor Unitário</label>
        <input pInputText type="text" (keyup)="somarValorTotal()" name="valorUnitario" placeholder="R$ 0,00"
          currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false }"
          [(ngModel)]="detalhamentoFinanceiroHasEtapaCronogramaFisicoAdd.valorUnitario" required>
      </div>
      <div class="ui-g-12 ui-md-3 ui-fluid">
        <label>*Valor Total</label>
        <input pInputText type="text" disabled name="valorTotal" placeholder="R$ 0,00" currencyMask
          [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', allowNegative: false }"
          [(ngModel)]="detalhamentoFinanceiroHasEtapaCronogramaFisicoAdd.valorTotal" required>
      </div>

    </div>
    <div class="ui-g-12">
      <hr>
      <button pButton type="submit" label="Salvar"
        [disabled]="formAdicionarDetalhamentoFinanceiroHasEtapaCronogramaFisico.invalid"></button>
      <small class="pull-right">*Preechimento obrigatório</small>
    </div>

  </form>
</p-dialog>